import React, { useState } from "react";
import { Dropdown, Menu, message } from "antd";
import moment from "moment";
import {
  FaCheck,
  FaEllipsisV,
  FaRegCalendarAlt,
  FaTimes,
} from "react-icons/fa";
import AppointmentActionForm from "./AppointmentActionForm";
import AppointmentFooter from "./AppointmentFooter";
import AppointmentStatusBadge from "./AppointmentStatusBadge";
import { APPOINTMENT_STATUS, formatDate } from "./constants";

const AppointmentItem = ({ item, onEditAppointment }) => {
  const [actionType, setActionType] = useState(null);
  const [inputRemark, setInputRemark] = useState("");

  const isPast = item.appointment_date
    ? moment(item.appointment_date).isBefore(moment())
    : false;

  const status = item.appointment_status;

  const handleConfirmComplete = () => {
    if (!inputRemark.trim()) {
      message.error("กรุณาระบุผลการติดต่อ");
      return;
    }
    onEditAppointment(item.id, item.appointment_date, item.appointment_note, {
      appointment_status: APPOINTMENT_STATUS.COMPLETE,
      appointment_remark: inputRemark.trim(),
    });
    setActionType(null);
    setInputRemark("");
  };

  const handleConfirmCancel = () => {
    if (!inputRemark.trim()) {
      message.error("กรุณาระบุเหตุผลการยกเลิก");
      return;
    }
    onEditAppointment(item.id, item.appointment_date, item.appointment_note, {
      appointment_status: APPOINTMENT_STATUS.CANCEL,
      appointment_remark: inputRemark.trim(),
    });
    setActionType(null);
    setInputRemark("");
  };

  const handleCancelAction = () => {
    setInputRemark("");
    setActionType(null);
  };

  const actionMenu = (
    <Menu style={{ borderRadius: "6px", minWidth: "150px" }}>
      <Menu.Item
        key="complete"
        onClick={() => {
          setInputRemark("");
          setActionType("complete");
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "12px",
            color: "#389e0d",
          }}
        >
          <FaCheck style={{ fontSize: "11px" }} />
          <span>เสร็จสิ้น</span>
        </span>
      </Menu.Item>
      <Menu.Item
        key="cancel"
        onClick={() => {
          setInputRemark("");
          setActionType("cancel");
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "12px",
            color: "#cf1322",
          }}
        >
          <FaTimes style={{ fontSize: "11px" }} />
          <span>ยกเลิก</span>
        </span>
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      className={`appointment-card-item ${
        isPast ? "appointment-card-past" : "appointment-card-active"
      } ${actionType ? "is-editing" : ""}`}
    >
      <AppointmentActionForm
        actionType={actionType}
        inputRemark={inputRemark}
        setInputRemark={setInputRemark}
        onCancel={handleCancelAction}
        onConfirmComplete={handleConfirmComplete}
        onConfirmCancel={handleConfirmCancel}
      />

      {!actionType && (
        <div>
          <div className="appt-card-header">
            <div className="appt-card-title-group">
              <FaRegCalendarAlt className="appt-icon" />
              <span className="appt-datetime-title">
                นัดหมาย: {formatDate(item.appointment_date)}
              </span>
              <AppointmentStatusBadge status={status} isPast={isPast} />
            </div>

            {(status === APPOINTMENT_STATUS.WAITING || !status) && (
              <div className="appt-card-actions">
                <Dropdown
                  overlay={actionMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  <button
                    type="button"
                    className="btn-action-icon btn-action-more"
                    title="ตัวเลือกเพิ่มเติม"
                  >
                    <FaEllipsisV style={{ fontSize: "11px" }} />
                  </button>
                </Dropdown>
              </div>
            )}
          </div>

          <div className="appt-compact-detail">
            {item.appointment_note || "ไม่มีรายละเอียดเพิ่มเติม"}
          </div>

          {item.appointment_remark && (
            <div
              style={{
                fontSize: "11px",
                color:
                  status === APPOINTMENT_STATUS.CANCEL ? "#cf1322" : "#389e0d",
                marginTop: "4px",
                fontWeight: "500",
              }}
            >
              {status === APPOINTMENT_STATUS.CANCEL
                ? "เหตุผลที่ยกเลิก: "
                : "ผลการติดต่อ: "}
              <span style={{ color: "#262626" }}>
                {item.appointment_remark}
              </span>
            </div>
          )}

          <AppointmentFooter
            createBy={item.create_by}
            createDate={item.create_date}
            updateBy={item.update_by}
            updateDate={item.update_date}
          />
        </div>
      )}
    </div>
  );
};

export default AppointmentItem;
